import { DateTime } from 'luxon'

import SeriesHostQ from '@/queries/SeriesHostQ'
import SeriesQ from '@/queries/SeriesQ'
import SessionHostQ from '@/queries/SessionHostQ'
import SessionQ from '@/queries/SessionQ'
import UserQ from '@/queries/UserQ'
import type { Query } from '@/client/query'
import { getActiveAnniversary } from '@/client/services/user'

import type { HostAvatarDetails } from './types'

export function getSessionHostAvatarDetails(session: Query): HostAvatarDetails[] {
  return session
    .many(
      SessionHostQ.where({
        sessionId: SessionQ.id,
        approved: true,
        include: [{ association: 'User', required: true }],
        order: [[SessionHostQ.role, 'desc']],
      })
    )
    .map(tutor => ({
      isSession: true,
      userId: tutor(UserQ.id) ?? 0,
      hostId: tutor(SessionHostQ.id) ?? 0,
      progressionLevel: tutor(UserQ.progression_level),
      avatarName: `${tutor(UserQ.display_name)}`,
      avatarSrc: `${tutor(UserQ.avatar_url)}`,
      username: tutor(UserQ.username),
      role: `${tutor(SessionHostQ.role)}`,
      activeAnniversary: getActiveAnniversary(DateTime.fromISO(`${tutor(UserQ.member_since)}`)),
      country: `${tutor(UserQ.country)}`,
      certificationCount: tutor(UserQ.countCertifications(UserQ.id)) ?? 0,
    }))
}

export function getSeriesHostAvatarDetails(series: Query): HostAvatarDetails[] {
  return series
    .many(
      SeriesHostQ.where({
        seriesId: SeriesQ.id,
        include: [
          {
            association: 'User',
            required: true,
          },
        ],
        approved: true,
        order: [[SeriesHostQ.role, 'desc']],
      })
    )
    .map(tutor => ({
      isSession: false,
      userId: tutor(UserQ.id) ?? 0,
      hostId: tutor(SeriesHostQ.id) ?? 0,
      progressionLevel: tutor(UserQ.progression_level),
      avatarName: `${tutor(UserQ.display_name)}`,
      avatarSrc: `${tutor(UserQ.avatar_url)}`,
      username: tutor(UserQ.username),
      role: `${tutor(SeriesHostQ.role)}`,
      bio: tutor(UserQ.bio) ?? '',
      activeAnniversary: getActiveAnniversary(DateTime.fromISO(`${tutor(UserQ.member_since)}`)),
      country: `${tutor(UserQ.country)}`,
      certificationCount: tutor(UserQ.countCertifications(UserQ.id)) ?? 0,
    }))
}
